import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const useStyles = makeStyles((theme) => ({
  container: {
    marginBlock: "20px",
    borderRadius: "12px",
    border: "1px solid #E8E8E8",
    backgroundColor: "white",
    padding: "24px",
  },
  informationItem: { display: "flex", alignItems: "center", marginTop: "8px" },
  informationItemIcon: {
    height: 22,
    width: 22,
    marginRight: "7px",
    color: "#022752",
  },
  note: {
    backgroundColor: "#FAFAFA",
    borderRadius: "12px",
    marginTop: "15px",
    padding: "15px",
  },
}));

const FranchiseInfo = ({ project }) => {
  const classes = useStyles();
  const {
    name: franchiseName,
    email: franchiseContactEmail,
    phoneNumber: franchisePhoneNumber,
  } = project?.franchiseDetails || {};

  return (
    <div className={classes.container}>
      <Typography variant="h4" color="primary" align="left" mb={2}>
        Your Local Franchise
      </Typography>

      {franchiseName && (
        <Typography variant="body2" className={classes.informationItem}>
          <BusinessIcon className={classes.informationItemIcon} />
          <span>{franchiseName}</span>
        </Typography>
      )}

      {franchiseContactEmail && (
        <Typography variant="body2" className={classes.informationItem}>
          <EmailIcon className={classes.informationItemIcon} />
          <span>{franchiseContactEmail}</span>
        </Typography>
      )}

      {franchisePhoneNumber && (
        <Typography variant="body2" className={classes.informationItem}>
          <PhoneIcon className={classes.informationItemIcon} />
          <span>{franchisePhoneNumber}</span>
        </Typography>
      )}

      <div className={classes.note}>
        <Typography variant="body2">
          This project is being handled directly by your local Helpful Heroes
          franchise{franchiseName ? `, ${franchiseName}` : ""}. Please reach
          out to them using the contact information above if you have any
          questions.
        </Typography>
      </div>
    </div>
  );
};

export default FranchiseInfo;
